import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'file-size-exceed-alert',
    templateUrl: './file-size-exceed-alert.component.html',
    styleUrls: ['./file-size-exceed-alert.component.scss'],
    standalone: true
})
export class FileSizeExceedAlertComponent {

	@Input() msg: string = '';

	constructor(public modal: NgbActiveModal) { }

	close() {
		this.modal.dismiss();
	}

}
